export class RegistrationFilter {
  search?:string;
  raceId?:number;
  eventId?:number;
  organiserId?:number;


  constructor(search?: string, raceId?: number, eventId?: number, organiserId?: number) {
    this.search = search;
    this.raceId = raceId;
    this.eventId = eventId;
    this.organiserId = organiserId;
  }
}
